import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import Select, { selectClasses } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase"; 
import { useAuth } from "../../context/AuthContext"; 
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { EventContext } from '../../pages/Dashboard';

const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function SelectContent() {
  const [company, setCompany] = React.useState('');
  const navigate = useNavigate();
  const { eventContext, setEventContext } = useContext(EventContext);

  const [eventDetails, setEventDetails] = useState(null);

  const handleChange = (event) => {
    setCompany(event.target.value);
  };

  // custom
  const { currentUser } = useAuth(); 
  const [events, setEvents] = useState([]);
  const [invitedEvents, setInvitedEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const q = query(
          collection(db, "events"),
          where("eventOwnerEmail", "==", currentUser.email)
        );

        const querySnapshot = await getDocs(q);

        const fetchedEvents = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setEvents(fetchedEvents);
      } catch (error) {
        console.error("Error fetching events:", error.message);
      }
    };

    if (currentUser?.email) {
      fetchEvents();
    }

    const fetchInvitedEvents = async () => {
      try {
        const eventsSnapshot = await getDocs(collection(db, "events"));
        const matchingEvents = [];

        for (const eventDoc of eventsSnapshot.docs) {
          const guestsRef = collection(db, "events", eventDoc.id, "guests");
          const guestsSnapshot = await getDocs(guestsRef);

          const isUserAGuest = guestsSnapshot.docs.some(
            guest => guest.data().guestEmail === currentUser.email
          );

          if (isUserAGuest) {
            matchingEvents.push({
              id: eventDoc.id,
              ...eventDoc.data()
            });
          }
        }

        setInvitedEvents(matchingEvents);
      } catch (error) {
        console.error("Error fetching invited events:", error);
      }
    };

    if (currentUser?.email) {
      fetchInvitedEvents();
    }

  }, [currentUser]);

  const updateContext = async (eventCode) => {
    const eventsRef = collection(db, 'events');
    const eventQuery = query(eventsRef, where('eventCode', '==', eventCode));
    const eventSnapshot = await getDocs(eventQuery);

    if (!eventSnapshot.empty) {
      // Assume the first matching event document
      const eventDoc = eventSnapshot.docs[0];
      const eventData = eventDoc.data();

      // Setting the page title 
      { document.title = "nKuvu - " + eventData.eventName }

      //setEventDocId(eventDoc.id);  // Store document ID for post retrieval
      setEventDetails({
        eventId: eventDoc.id,
        eventImage: eventData.eventImageURL,
        eventName: eventData.eventName,
        eventCode: eventData.eventCode,
        eventDescription: eventData.eventDescription,
        eventOwnerName: eventData.eventOwnerName,
        eventLatitude: eventData.eventLatitude,
        eventLongitude: eventData.eventLongitude,
        eventCity: eventData.eventCity,
        eventLocation: eventData.eventLocation,
        eventStartDate: eventData.eventStartDate,
      });
    }
  }
  
  return (
    <Select
      labelId="company-select"
      id="company-simple-select"
      value={company}
      onChange={handleChange}
      displayEmpty
      inputProps={{ 'aria-label': 'Select company' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 215,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      <ListSubheader sx={{ pt: 0 }}>My events</ListSubheader>
      {events.map(event => (
        <MenuItem 
          key={event.id} 
          value={event.id} 
          component={Link} 
          to={`/admin/${event.eventCode}`} 
          onClick={updateContext(event.eventCode)}
          >
        <ListItemAvatar>
          <Avatar alt="Sitemark web" src={event.eventImageURL}/>
        </ListItemAvatar>
        <ListItemText primary={event.eventName} secondary={event.eventLocation} />
        </MenuItem>        
      ))}
            
      <ListSubheader>Invitations</ListSubheader>
      {invitedEvents.map(event => (
        
        <MenuItem 
          key={event.id} 
          value={event.id} 
          to={`/admin/${event.eventCode}`} 
          onClick={updateContext(event.eventCode)}
          >
        <ListItemAvatar>
          <Avatar alt={event.eventName}
            src={event.eventImageURL}            
            width="150" 
            />
        </ListItemAvatar>
        <ListItemText primary={event.eventName} secondary={event.eventLocation} />
        </MenuItem>
      ))}
           
      <Divider sx={{ mx: -1 }} />
      <MenuItem value={40}>
        <ListItemIcon>
          <AddRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Create an event"  />
      </MenuItem>
    </Select>
  );
}
